// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Chad from '../_raw/flag/icon_flag_chad.png';

export default () => <img src={Chad} alt="Chad" />;
